import { useState } from "react";
import { Divider, Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import Drawer from "ui-components/Drawer";
import { soStatusLabel } from "layouts/views/common/enum";
import { getPickslipLog } from "services/data.outbound.service";
import MDTypography from "components/MDTypography";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";

const columns = [
  { label: "SKU Code", id: "skuCode" },
  { label: "Zone ID", id: "zoneID" },
  { label: "Location ID", id: "locationID" },
  { label: "Pallet Number", id: "palletNbr" },
  { label: "Carton ID", id: "cartonID" },
  { label: "Quantity Allocate", id: "quantityAllocate" },
  { label: "Quantity Picked", id: "quantityPicked" },
  { label: "MLN", id: "mln" },
  { label: "Expiry Date", id: "expiryDate" },
  { label: "Base UOM", id: "baseUOM" },
  { label: "Status", id: "status" },
];

function PickslipLog({ open, setOpen, logRequest, setLogRequest }) {
  //const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["pickslip-log", { logRequest }],
    queryFn: () => getPickslipLog(logRequest),
    enabled: logRequest !== null,
    onSuccess: (data) => {
      console.log(data.data.data);
      const item = data.data.data;

      const renderTimelineItems = item.logs.map(({ id, ...log }) => (
          <TimelineItem key={id} {...log} />
      ));
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Pickslip Number : </b>
                {item.pickslipNumber}
              </Grid>
              <Grid item xs={6}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>
              <Grid item xs={6}>
                <b>Order Number : </b>
                {item.orderNumber}
              </Grid>
              <Grid item xs={6}>
                <b>Wave Number : </b>
                {item.waveNumber}
              </Grid>
              <Grid item xs={6}>
                <b>Warehouse Code : </b>
                {item.warehouseCode}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable
              columns={columns}
              rows={item.details.map((x) => ({ ...x, status: soStatusLabel[x.status] }))}
            />
          </div>
          {renderTimelineItems.length > 0 && (<TimelineList title="Logs">{renderTimelineItems}</TimelineList>)}     
        </>
      );
      //setLogRequest({ coNumber: "", custCode: "" });
    },
    //onError,
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setLogRequest(null);
  };

  return (
    <Drawer width="1400px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      <MDTypography variant="h5" color="info">
        Pickslip
      </MDTypography>
      <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
      {logs}
    </Drawer>
  );
}

export default PickslipLog;
